import * as Yup from 'yup';

export const initialValues = {
    communicationArchitecture: [
        { title: 'Modo Rápido', description: '' },
        { title: 'Modo explicativo', description: '' },
        { title: 'Modo escalamiento', description: '' },
    ],
};

export const validationSchema = Yup.object().shape({
    communicationArchitecture: Yup.array().of(
        Yup.object().shape({
            title: Yup.string().required('Requerido'),
            description: Yup.string().required('Requerido'),
        })
    ),
});
